export { default } from './GroupSearchFeedbackButton';



// WEBPACK FOOTER //
// ./app/components/GroupSearchFeedbackButton/index.js